import { Alert, Snackbar } from '@mui/material';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';

interface Props {
  snackbarOpen: boolean;
  errorMessage: string;
}

const SubmitSnackbar: React.FC<Props> = ({ snackbarOpen, errorMessage }) => {
  const { t } = useTranslation();

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={snackbarOpen}
    >
      <Alert severity={errorMessage ? 'error' : 'success'}>
        {t(errorMessage || 'Success!', { ns: 'common' })}
      </Alert>
    </Snackbar>
  );
};

export default SubmitSnackbar;
